module.exports = __webpack_public_path__ + "static/media/0294_Small.c3d3124e.jpg";